"use client";
import { useState as n, useCallback as t } from "react";
function f(o = !1) {
  if (typeof o != "boolean")
    throw new Error("defaultValue must be `true` or `false`");
  const [s, e] = n(o), r = t(() => {
    e(!0);
  }, []), l = t(() => {
    e(!1);
  }, []), u = t(() => {
    e((a) => !a);
  }, []);
  return { value: s, setValue: e, setTrue: r, setFalse: l, toggle: u };
}
export {
  f as useBoolean
};
